import { h } from 'preact';
import { useRef, useState } from 'preact/hooks';

const KitOptionGroup = ({ label, products, updateKitSelection }) => {
  const [selectedOption, setSelectedOption] = useState(products?.[0].id);
  const selectRef = useRef();

  const onChange = (e) => {
    setSelectedOption(e.target.value);
    const selectedProduct = products.find(
      (product) => product.id === e.target.value,
    );
    updateKitSelection(selectedProduct);
  };

  return (
    <div>
      <label className="block font-13-bold mb-2">{label || 'Select one'}</label>  
      <select
        className="select w-full mb-5"
        data-kit-select
        ref={selectRef}
        value={selectedOption}
        onChange={onChange}>
        {products.map((product) => {
          const isAvailable = product?.variants[0] 
            ? product.variants[0].availableForSale 
            : product?.variants.edges[0].node.availableForSale;

          return ( 
           <option
            key={product.id}
            value={product.id}
            disabled={!isAvailable}
            >{product.title}{!isAvailable && ' - out of stock'}
            </option>
        )})}
      </select>
    </div>
  );
};

export default KitOptionGroup;
